// Generated by scripts/i18n-check.js. Do not edit.
//
// Hash of the English catalogue plus the translation overrides. The app requests translations at
// /api/translations/<locale>/<version>, so the URL identifies the exact catalogue being
// rendered. That makes the response immutable and edge-cacheable, and it means a mismatch
// between what the UI renders and what the API translates is caught rather than silent.
export const CATALOG_VERSION = 'a00dd560cb38f133';
